import { Link } from 'react-router-dom';
import LegalLayout from '@/components/LegalLayout';
import { BUSINESS } from '@/lib/legal';

export default function About() {
  return (
    <LegalLayout
      title="About Us"
      updated={false}
      intro="Daily Fresh. Daily Different."
    >
      <h2>Our story</h2>
      <p>
        {BUSINESS.legalName} brings home-style Indian tiffins to {BUSINESS.city}. We cook fresh every day in small
        batches, with a menu that rotates so there's always something to look forward to — real food, made the way
        home does it.
      </p>

      <h2>How it works</h2>
      <p>
        Choose a prepaid tiffin plan, get your personal QR pass, and pick up wholesome meals whenever you like — no
        daily ordering, no cooking, no cleanup. Show your QR at the counter and we take care of the rest.
      </p>

      <h2>Serving {BUSINESS.city}</h2>
      <ul>
        <li><strong>Address:</strong> {BUSINESS.address}</li>
        <li><strong>Hours:</strong> {BUSINESS.hours}</li>
        <li><strong>Phone:</strong> <a href={`tel:${BUSINESS.phone}`}>{BUSINESS.phone}</a></li>
        <li><strong>Email:</strong> <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a></li>
      </ul>

      <h2>Get in touch</h2>
      <p>
        Questions or feedback? Visit our <Link to="/support">Support &amp; Contact</Link> page or email{' '}
        <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a>. Ready to start?{' '}
        <Link to="/register">Create an account</Link>.
      </p>
    </LegalLayout>
  );
}
